import Afrikan from '../../images/portfolio/afrikan.jpg';
import Aitoze from '../../images/portfolio/aitoze.jpg';
import Anya from '../../images/portfolio/anya.jpg';
import TeenGirlsUp from '../../images/portfolio/teengirlsup.jpg';
import Nephilim from '../../images/portfolio/nephilim.jpg';

const gigs = [
  {
    id: 1,
    title: 'This is Afrikan',
    category: 'Online Store with logistics',
    view: 'https://thisisafrikan.com',
    pertfolioImg: Afrikan,
    details:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Error, nihil, voluptatibus quis maiores voluptatem nostrum aut ducimus commodi natus nam, in recusandae tempora! Dicta quas praesentium nulla id, cumque eum. Libero rem consectetur atque fugit.',
    popupImg: ['link1', 'link2', 'link3'],
  },
  {
    id: 2,
    title: 'Aitoze Dating',
    category: 'Dating and Match Making',
    view: 'http://ennyephraim.com/wp4bb/',
    pertfolioImg: Aitoze,
    details:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Error, nihil, voluptatibus quis maiores voluptatem nostrum aut ducimus commodi natus nam, in recusandae tempora! Dicta quas praesentium nulla id, cumque eum. Libero rem consectetur atque fugit.',
    popupImg: ['link1', 'link2', 'link3'],
  },
  {
    id: 3,
    title: 'Anya',
    category: 'Marketplace and Advertising Agency',
    view: 'https://anya.ng',
    pertfolioImg: Anya,
    details:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Error, nihil, voluptatibus quis maiores voluptatem nostrum aut ducimus commodi natus nam, in recusandae tempora! Dicta quas praesentium nulla id, cumque eum. Libero rem consectetur atque fugit.',
    popupImg: ['link1', 'link2', 'link3'],
  },
  {
    id: 4,
    title: 'Teen Girls Up',
    category: 'Photo Contest Web App',
    view: '#',
    pertfolioImg: TeenGirlsUp,
    details:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Error, nihil, voluptatibus quis maiores voluptatem nostrum aut ducimus commodi natus nam, in recusandae tempora! Dicta quas praesentium nulla id, cumque eum. Libero rem consectetur atque fugit.',
    popupImg: ['link1', 'link2', 'link3'],
  },
  {
    id: 5,
    title: 'Nephilim Tech',
    category: 'Solar Energy',
    view: 'https://nephilimtech.com/',
    pertfolioImg: Nephilim,
    details:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Error, nihil, voluptatibus quis maiores voluptatem nostrum aut ducimus commodi natus nam, in recusandae tempora! Dicta quas praesentium nulla id, cumque eum. Libero rem consectetur atque fugit.',
    popupImg: ['link1', 'link2', 'link3'],
  },
];

export default gigs;
